import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type HealthPlan = ApiSchemas['HealthPlanPresenter']

export default {
  async getById(id: number) {
    return wrapEndpoint(() =>
      client.GET('/health-plan/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async list(options?: ApiSchemas['ListHealthPlanDto']) {
    return wrapEndpoint(() =>
      client.GET('/health-plan', {
        params: {
          query: options,
        },
      }),
    )
  },
  async create(body: ApiSchemas['CreateHealthPlanDto']) {
    return wrapEndpoint(() =>
      client.POST('/health-plan', {
        body,
      }),
    )
  },
  async updateById(id: number, body: ApiSchemas['UpdateHealthPlanDto']) {
    return wrapEndpoint(() =>
      client.PUT('/health-plan/{id}', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
  async deleteById(id: number) {
    return wrapEndpoint(() =>
      client.DELETE('/health-plan/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
